export default __webpack_public_path__ + "static/media/FINANCE-01.5f60ae51.png";